export default __webpack_public_path__ + "static/ens-d1e77695934199e3fb7a52598485c804.png";